export default __webpack_public_path__ + "static/media/immutable_drop_banner.e1988229.png";